import { createSlice } from '@reduxjs/toolkit';
import { addToBreadcrumbs } from './actions/addToBreadcrumbs';
import { clearBreadcrumbs } from './actions/clearBreadcrumbs';
import { deleteFromBreadcrumbs } from './actions/deleteFromBreadcrumbs';

const breadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState: {
    path: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(addToBreadcrumbs, (state, action) => {
        state.path = [...state.path].includes(action.payload)
          ? [...state.path]
          : [...state.path, action.payload];
      })
      .addCase(deleteFromBreadcrumbs, (state, action) => {
        state.path = [...state.path].filter((key) => key !== action.payload);
      })
      .addCase(clearBreadcrumbs, (state, action) => {
        state.path = [];
      });
  },
});

export default breadcrumbsSlice.reducer;
